import React, {useEffect} from 'react'

import {motion, useAnimation} from 'framer-motion'

export const Why = () => {
  const controls = useAnimation()
  useEffect(() => {
    const element = document.querySelector('.CustomAI__why')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])
  const data = [
    {
      title: 'Customer-Centric Approach',
      des: 'เพราะประสบการณ์ลูกค้าคือสิ่งที่เราให้คุณค่า เราจึงให้บริการลูกค้าอย่างดีที่สุด ถ่ายทอดตามแบบฉบับวัฒนธรรมญี่ปุ่น',
      key: 'customer',
    },
    {
      title: 'End-to-End Services',
      des: 'บริการด้าน AI ครบวงจร การวิเคราะห์ข้อมูล การทำ ETL (Extract, Transform, Load) การจัดเตรียมข้อมูล การทำ Model Training และ Deployment โดยมีทีมงานซัพพอร์ตตลอดโปรเจกต์',
      key: 'end',
    },
    {
      title: 'Tailored AI Solutions',
      des: 'AI โซลูชัน ที่สามารถปรับแต่งได้ตามความต้องการของธุรกิจด้วยผู้เชี่ยวชาญด้าน AI',
      key: 'ai',
    },
    {
      title: 'Highly Experienced In-house Tech Experts',
      des: 'เรามีทีมผู้เชี่ยวชาญครบครัน Data Scientists, Data Engineers, Data Consultants และ Developers',
      key: 'highly',
    },
    {
      title: 'Fast, Flexible, and Scalable',
      des: 'อยู่เหนือการแข่งขันด้วยการพัฒนาที่ไม่หยุดนิ่ง ปรับตัวให้ทันกับทุกการเปลี่ยนแปลงได้อย่างรวดเร็วและก้าวข้ามขีดจำกัดของทรัพยากรได้',
      key: 'fast',
    },
    {
      title: 'Certified Data Security and Privacy Provider',
      des: 'ได้รับรองตามมาตรฐาน ISO 27001 และ ISO 27701 มุ่งเน้นด้านความปลอดภัยและความเป็นส่วนตัวของข้อมูล',
      key: 'certified',
    },
  ]

  return (
    <motion.div
      className='CustomAI__why'
      initial={{opacity: 0, y: 10}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <div className='CustomAI__why__container'>
        <h2>
          ทำไมต้อง
          <span>Data Wow ? </span>
        </h2>
        <div className='CustomAI__why__container__content'>
          {data.map((item) => {
            return (
              <motion.div key={item.key} className='card' id={item.key}>
                <picture className='card__image'>
                  <img
                    className='img'
                    src={`/images/custom-ai/why-${item.key}.svg`}
                    alt={item.title}
                    loading='lazy'
                    width='210'
                    height='160'
                  />
                </picture>
                <div className='card__content'>
                  <h3>{item.title}</h3>
                  <p>{item.des}</p>
                </div>
              </motion.div>
            )
          })}
        </div>
      </div>
      <div className='CustomAI__why__bg'>
        <img
          className='CustomAI__why__bg__image'
          src='/images/custom-ai/why-bg.png'
          alt='why-bg-vector'
        />
      </div>
    </motion.div>
  )
}
